export const helperClearStake = (setante: any, setanteHistory: any) => {
    setante('0')
    setanteHistory(['0'])
}
